'use client';

import { ScEmblaPagination } from './styled';

interface IEmblaPaginationProps {
  count: number;
  selectedIndex: number;
  onSelect: (index: number) => void;
  compact?: boolean;
}

export const EmblaPagination = ({
  count,
  selectedIndex,
  onSelect,
  compact,
}: IEmblaPaginationProps) => {
  const bullets = Array.from({ length: count }, (_, i) => i);

  return (
    <ScEmblaPagination $compact={compact}>
      {bullets.map((bulletIndex) => (
        <button
          aria-current={bulletIndex === selectedIndex ? 'true' : undefined}
          aria-label={`Go to slide ${bulletIndex + 1}`}
          className={`pagination-bullet ${bulletIndex === selectedIndex ? 'active' : ''}`}
          key={`bullet-${bulletIndex}`}
          onClick={() => onSelect(bulletIndex)}
          type="button"
        />
      ))}
    </ScEmblaPagination>
  );
};
